import React, { useState, useEffect } from "react";

const Topnav = () => {
  const announcements = [
    "NEW SEASON, NEW OFFER: YOU CAN'T MISS",
    "FREE DELIVERY OVER ₹5000",
    "EASY RETURNS & EASY REFUNDS",
    "LIMITED TIME OFFERS: ONLY FOR YOU",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-rotate through announcements
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % announcements.length);
    }, 3000); // Change announcement every 3 seconds

    return () => clearInterval(timer);
  }, [announcements.length]);

  return (
    <div className="bg-[#36454F] text-white w-full py-1">
      <div className="px-4 sm:px-6 lg:px-8">
        {/* Mobile view - carousel */}
        <div className="md:hidden">
          <div className="flex flex-col items-center">
            <div className="text-xs sm:text-sm font-medium text-center">
              {announcements[currentIndex]}
            </div>
          </div>
        </div>

        {/* Desktop view - all announcements in a sliding row */}
        <div className="hidden md:block">
          <div className="overflow-hidden">
            <div className="whitespace-nowrap animate-slide-right hover:animate-none flex gap-8 px-6">
              {[...announcements, ...announcements].map(
                (announcement, index) => (
                  <div
                    key={index}
                    className="flex items-center cursor-pointer hover:text-yellow-300 transition-colors duration-300"
                  >
                    <span className="text-xs font-light tracking-wide">
                      {announcement}
                    </span>
                    <span className="text-gray-400 mx-2">—</span>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topnav;
